import type { AnalyticsData } from "../types";
import { webEvent } from "./event";

const event = (name: string, data?: AnalyticsData) => webEvent("kanban_board", name, data);

export const kanbanBoardFilterUsed = (filter: "user" | "type" | "text" | "art" | "team") =>
  event("filter_used", { kanbanBoardFilter: filter });

export const kanbanBoardFiltersCleared = () => event("filters_cleared");

export const kanbanBoardStickyChipClicked = (chipName: string) =>
  event("sticky_chip_clicked", { chipName });

export const kanbanBoardStickyDragStarted = () => event("sticky_drag_started");

export const kanbanBoardHorizontalScrollUsed = () => event("horizontal_scroll_used");
